if (!customElements.get("loyalty-signup-drawer")) {
  customElements.define(
    "loyalty-signup-drawer",
    class LoyaltySignupDrawer extends DrawerComponent {},
  );
}

(function () {
  const STORAGE_KEY = "loyalty-teaser-closed";
  const wrap = document.querySelector(".loyalty-signup-drawer__teaser-wrapper");

  // Teaser visibility
  if (wrap) {
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      wrap.hidden = false;
      wrap
        .querySelector(".loyalty-signup-drawer__teaser-close")
        ?.addEventListener("click", () => {
          sessionStorage.setItem(STORAGE_KEY, "1");
          wrap.hidden = true;
        });
    }
  }

  // Prefix phone note field before submission with "Mobile: "
  const form = document.querySelector('[id^="LoyaltySignUp-"]');
  if (form) {
    form.addEventListener("submit", () => {
      const phoneField = form.querySelector('[id^="NewsletterFormPhone-"]');
      const noteField = form.querySelector('[id^="NewsletterFormNote-"]');
      if (phoneField && noteField && phoneField.value.trim()) {
        noteField.value = `Mobile: ${phoneField.value.trim()}`;
      }
    });
  }
})();